import React from 'react';

const CheckedCircleHeavyIcon = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="checked-circle-heavy-icon"
  >
    <circle cx="22" cy="22" r="11" fill="#171717" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.0303 18.4697C27.3232 18.7626 27.3232 19.2374 27.0303 19.5303L21.2071 25.3536C20.8166 25.7441 20.1834 25.7441 19.7929 25.3536L17.4697 23.0303C17.1768 22.7374 17.1768 22.2626 17.4697 21.9697C17.7626 21.6768 18.2374 21.6768 18.5303 21.9697L20.5 23.9393L25.9697 18.4697C26.2626 18.1768 26.7374 18.1768 27.0303 18.4697Z"
      fill="#FAFAFA"
    />
  </svg>
);

export default CheckedCircleHeavyIcon;
